/* Mobile menu */
document.querySelectorAll('[data-nav-toggle]').forEach(function(b){b.addEventListener('click',function(){document.body.classList.toggle('nav-open');});});
document.querySelectorAll('.mobile-menu a').forEach(function(a){a.addEventListener('click',function(){document.body.classList.remove('nav-open');});});

/* Graceful image fallback -> branded plum panel */
function bindFallback(imgSel, parentSel){
  document.querySelectorAll(imgSel).forEach(function(img){
    function fb(){var p=img.closest(parentSel); if(p)p.classList.add('no-img');}
    img.addEventListener('error', fb);
    if(img.complete && img.naturalWidth===0) fb();
  });
}
bindFallback('.stack-media img','.stack');
bindFallback('.prod-media img','.prod');
bindFallback('.g-media img','.g-item');

/* Note: the contact form on the Contact page now posts to Shopify's built-in
   contact form handler ({% form 'contact' %}) instead of opening a mailto
   link. Messages arrive in the store's Customer contact form notification
   email, configurable in Shopify admin under Settings > Notifications. */
